import { render, staticRenderFns } from "./LicenceUploader.vue?vue&type=template&id=1f9e9ad6&scoped=true"
import script from "./LicenceUploader.vue?vue&type=script&lang=js"
export * from "./LicenceUploader.vue?vue&type=script&lang=js"
import style0 from "./LicenceUploader.vue?vue&type=style&index=0&id=1f9e9ad6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e9ad6",
  null
  
)

export default component.exports